import Vue from "vue"
import Router from "vue-router"
import Home from "./views/Home.vue"
import Reiki from "./views/Reiki.vue"
import Lahochi from "./views/Lahochi.vue"
import Reflexologie from "./views/Reflexologie.vue"
import ContactEssars from "./views/ContactEssars.vue"

import Prevention from "./views/Prevention.vue"
import Gift from "./views/Gift.vue"
import Massage from './views/Massage.vue'
import Maison from './views/Maison.vue'
import Formation from './views/Formation.vue'
import Shiatsu from './views/Shiatsu.vue'

Vue.use(Router)

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [
    {
      path: "/",
      name: "home",
      component: Home
    },
    {
      path: "/reiki",
      name: "reiki",
      component: Reiki
    },
    {
      path: "/massage",
      name: "massage",
      component: Massage
    },
    {
      path: "/maison",
      name: "maison",
      component: Maison
    },
    {
      path: "/lahochi",
      name: "Lahochi",
      component: Lahochi
    },
    {
      path: "/formation",
      name: "Formation",
      component: Formation
    },
    {
      path: "/reflexologie",
      name: "reflexologie",
      component: Reflexologie
    },
    {
      path: "/contact-essars",
      name: "contactEssars",
      component: ContactEssars
    },
    {
      path: "/prevention",
      name: "Prevention",
      component: Prevention
    },
    {
      path: "/gift",
      name: "gift",
      component: Gift
    },
    {
      path: "/shiatsu",
      name: "shiatsu",
      component: Shiatsu
    }
  ]
})

router.beforeEach(function (to, from, next) {
  window.scrollTo(0, 0)
  next();
})

export default router
